<template>
  <div>
    <el-table
      class="table-normal animate__animated animate__fadeIn animate__slow"
      :data="dataAppeove"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="กำลังโหลดข้อมูล..."
      element-loading-spinner="el-icon-loading"
    >
      <template slot="empty">
        <p class="font-30 font-weight-500">ไม่พบข้อมูลที่คุณค้นหา</p>
      </template>
      <el-table-column prop="leadId" label="leadRefId" width="85px">
      </el-table-column>
      <el-table-column prop="customerId" label="custCode" width="85px">
      </el-table-column>
      <el-table-column
        prop="juristicId"
        label="juristicOrPersonId"
        width="140px"
      >
      </el-table-column>
      
      <el-table-column prop="contactName" label="contactName" min-width="150px">
      </el-table-column>
      
      <el-table-column prop="contactPositon" label="contactPositon" min-width="150px">
      </el-table-column>
      <el-table-column prop="contactByEmp" label="contactByEmp" width="90px">
      </el-table-column>
      
      <el-table-column
        prop="updatedAt"
        label="contactDate"
        width="120px"
      >
        <template slot-scope="scope">
          {{ scope.row.contactData | formatDateTH }}
        </template>
      </el-table-column>
      <el-table-column
        prop="contactObjective"
        label="contactPurpose"
        width="150px"
      >
      </el-table-column>
      
      <el-table-column
        prop="contactPurposeOther"
        label="contactPurposeOther"
        width="120px"
      >
      </el-table-column>
      
      <!-- <el-table-column
        prop="contactData"
        label="วัตถุประสงค์ในการติดต่อ อื่นๆ"
        min-width="150px"
      >
      </el-table-column> -->
      <el-table-column
        prop="meetStatus"
        label="callMemoStatus"
        width="150px"
      >
      </el-table-column>

      <el-table-column
        width="85px"
        prop="meetDetail"
        label="callMemoDetail"
      >
      </el-table-column>
       <el-table-column
        width="130px"
        prop="eximDescriptionTopics"
        label="exim_description_topics"
      >
      </el-table-column>
       <el-table-column
        width="200px"
        prop="callMemoDetailOther"
        label="callMemo DetailOther"
      >
      </el-table-column>
        <el-table-column
        width="150px"
        prop="callMemoGuid"
        label="callMemoGuid"
      >
      </el-table-column>
    </el-table>

    <div class="text-center mg-t-5">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="changePage"
        :current-page.sync="page"
        :page-sizes="[10, 30, 50, 100, 500]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNow"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataAppeove: {
      type: Array,
      default() {
        return [];
      },
    },

    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },

    totalNow: {
      type: Number,
      default() {
        return 0;
      },
    },
    pageNow: {
      type: Number,
      default() {
        return 0;
      },
    },
    limit: {
      type: Number,
      default() {
        return 10;
      },
    },
  },
  data() {
    return {
      page: 0,
    };
  },
  mounted() {
    this.page = this.pageNow;
  },
  methods: {
    changePage(page) {
      this.$emit("changePage", page);
    },
    handleSizeChange(page) {
      this.$emit("handleSizeChange", page);
    },
  },
};
</script>

<style></style>
